import axios from "axios";
import { store } from "../store";
import config from "../config";
import authHeader from "./auth-header";
import { encodeQueryValue } from "./queryString";
import { catalogLegacyQuery, catalogListLimit, localCatalogAction } from "./catalogRequest";

const API_URL = config.API_URL;

const create = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();
  for (let value in values) {
    if (["subservice", "products", "discount_code_ids", "propagation"].includes(value) && values[value] && typeof values[value] === "object") {
      formData.append(value, JSON.stringify(values[value]));
    } else {
      formData.append(value, values[value]);
    }
  }
  const action = "afterlogin/membership/store";
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const update = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();
  for (let value in values) {
    if (["subservice", "products", "discount_code_ids", "propagation"].includes(value) && values[value] && typeof values[value] === "object") {
      formData.append(value, JSON.stringify(values[value]));
    } else {
      formData.append(value, values[value]);
    }
  }
  const action = "afterlogin/membership/update/" + values.id;
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const view = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const sort = values && values.sort;
  const result = values && values.result ? values.result : "";
  let sortstring = "";
  if (sort) {
    let sortArray = [];
    Object.keys(sort).map(function (key, index) {
      return (sortArray[index] = `sort[${key}]=${sort[key]}`);
    });
    if (sortArray.length > 0) {
      let jsort = sortArray.join("&");
      sortstring = jsort;
    }
  }
  let pagination = true;
  if(values){
    if(values.id){
      pagination = false;
    }
    if(values.option){
      pagination = false;
    }
    if(typeof values.pagination === "boolean"){
      pagination = values.pagination;
    }
  }
  const action = localCatalogAction("afterlogin/membership/view", values, sortstring);
  const data = {
    auth_key: auth_key,
    action: action,
    pagination: pagination, //true or false
    id: values && values.id ? values.id : "",
    result: result, //business_name,owner_name
    option: values && values.option ? values.option : "",
  };
  const limit = catalogListLimit(values);
  if (limit) data.limit = limit;
  data.action = action;
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const deleted = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = `afterlogin/membership/delete/${values.id}`;
  const data = {
    auth_key: auth_key,
    action: action,
  };
  return axios.post(API_URL + action, data, { headers: authHeader(), ...(values.archive === true ? { deleteConfirmation: false } : {}) });
};

const suggetionlist = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  let q = typeof (values && values.q) === "string" ? values.q : catalogLegacyQuery(values, "q") || "";
  const encodedQ = encodeQueryValue(q);
  const action = localCatalogAction("afterlogin/membership/view", values, `q=${encodedQ}`);
  const data = {
    auth_key: auth_key,
    action: action,
    pagination: true, //true or false
    id: values && values.id ? values.id : "",
    apicall: "suggetion",
    q,
  };
  const limit = catalogListLimit(values);
  if (limit) data.limit = limit;
  data.action = action;
  return axios.post(API_URL + action, data, { headers: authHeader() });
};


const services = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const page = values && values.page;
  const next_page_url = values && values.next_page_url;
  const parsedServiceId = Number(values && values.service_id);
  let service_id = Number.isInteger(parsedServiceId) && parsedServiceId > 0 ? parsedServiceId : 0;
  let staff = values && values.staff ? values.staff : "";
  let gprice = values && values.gprice ? values.gprice : "";
  let q = values && values.q ? values.q : "";
  const encodedQ = encodeQueryValue(q);
  const serviceIdQuery = service_id || "";
  const action = page ? `afterlogin/membership/services?page=${page}&service_id=${serviceIdQuery}&q=${encodedQ}` : `afterlogin/membership/services?service_id=${serviceIdQuery}&q=${encodedQ}`;
  const data = {
    auth_key: auth_key,
    action: action,
    staff: staff,
    gprice: gprice,
    q,
  };
  if (service_id) data.service_id = service_id;
  const pageNumber = Number(values && values.page);
  const limit = Number(values && values.limit);
  if (Number.isInteger(pageNumber) && pageNumber > 0) data.page = pageNumber;
  if (Number.isInteger(limit) && limit > 0) data.limit = limit;
  return axios.post(next_page_url ? `${next_page_url}` : API_URL + action, data, { headers: authHeader() });
};

const owners = (values = {}) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const membershipId = values.membership_id || values.id;
  const action = `afterlogin/membership/owners/${membershipId}`;
  return axios.post(API_URL + action, { auth_key, action }, { headers: authHeader() });
};

const previewUpdate = (values = {}) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const membershipId = values.id || values.membership_id;
  const action = `afterlogin/membership/update/${membershipId}/preview`;
  return axios.post(
    API_URL + action,
    { ...values, auth_key, action },
    { headers: authHeader() },
  );
};

const membershipApiController = {
  create,
  update,
  view,
  deleted,
  suggetionlist,
  services,
  owners,
  previewUpdate,
};
export default membershipApiController;
